import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Dashboard from './Dashboard';
import { MenuIcon, XIcon } from 'lucide-react';
interface LayoutProps {
  children?: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="flex h-screen bg-gray-100" data-id="element-1282">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-1283">
        {/* Sidebar backdrop */}
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-1284"></div>
        {/* Sidebar */}
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black overflow-hidden" data-id="element-1285">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-1286">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-1287">
              <span className="sr-only" data-id="element-1288">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-1289" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-1290">
            <Sidebar activePage="formazione" data-id="element-1291" />
          </div>
        </div>
      </div>
      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-1292">
        <Sidebar activePage="formazione" data-id="element-1293" />
      </div>
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-1294">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-1295" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-0 md:pt-0 bg-gray-100" data-id="element-1296">
          <div className="pt-4 md:pt-6" data-id="element-1297">
            <Dashboard data-id="element-1298" />
          </div>
        </main>
      </div>
    </div>;
};
export default Layout;